export default __webpack_public_path__ + "static/media/hard-hat-icon.676a14b0.svg";